import React, { FC } from "react";
import { SVGProps } from '@utils';
import { SvgWrapper } from "./SvgWrapper";

export const BlueArrowUp: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.8553 0L0 7.63251L1.40741 9L7.8553 2.73498L14.3032 9L15.7106 7.63251L7.8553 0Z" fill="#3273E1"/>
    </svg>
  </SvgWrapper>
);
